export default () => ({
  list: null,
  totalCount: null,
  pagesLoaded: 0,
  finished: false,
})